export default "__VITE_ASSET__9fdf11bc__"